import Icon from "@material-ui/icons/SupervisedUserCircle";
import CreditNoteList from "./CreditNoteList";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "creditNotes",
  list: CreditNoteList,
  icon: Icon,
};
